import {
    HttpClient,
} from '@angular/common/http';
import {
    inject,
    Injectable
} from '@angular/core';
import {
    Observable
} from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ForensicService {
    private readonly _httpClient = inject(HttpClient);
    private readonly API_URL = environment.apiUrl;

    getMessageSealedReport(message: any): Observable <Blob> {
        return this._httpClient.get(`${this.API_URL}/forensic/messages/${message.id}/sealed_report`, { responseType: 'blob' });
    }

}
